import React,{useState,useEffect} from 'react'
import {Table} from "reactstrap";
import {selfSales} from 'network/ApiAxiosTickets'


function DaySelfSales() {
    const [deposits, setDeposits] = useState({});
    useEffect(() => {
        getTotalDepositList()
    }, []);

    const getTotalDepositList =async()=>{
        const sellerID = JSON.parse(localStorage.getItem("user"))._id;
        const {data} = await selfSales(sellerID)
        if(data.success){
            console.log(data)
            setDeposits(data)
        }
    }
  return (
    <Table className="text-white" responsive>
        <thead>
            <tr>
                <th>
                    Event
                </th>
                <th>
                    Tickets
                </th>
            </tr>
        </thead>
        <tbody>
        {deposits.responeTotals && Object.entries(deposits.responeTotals.eventName).map((row)=>{
            return <tr key={row[0]}><th scope="col" className=' text-wrap'>{row[0]}</th><th scope="col">{row[1]}</th></tr>
        })}
        {deposits.responeTotals && <tr><th scope="col"></th><th scope="col">{deposits.responeTotals.total}</th></tr>}
        </tbody>
    </Table>
  )
}

export default DaySelfSales